import { z } from 'zod';

export const approvalPayloadSchema = z.object({
  prompt: z.string().min(1),
  draft: z.string().optional(),
});

export const choiceOptionSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1).optional(),
});

export const choicePayloadSchema = z.object({
  prompt: z.string().min(1),
  options: z.array(choiceOptionSchema).min(1),
});

export const textInputPayloadSchema = z.object({
  prompt: z.string().min(1),
  placeholder: z.string().optional(),
  multiline: z.boolean().optional(),
});

export type ApprovalPayload = z.infer<typeof approvalPayloadSchema>;
export type ChoicePayload = z.infer<typeof choicePayloadSchema>;
export type ChoiceOption = z.infer<typeof choiceOptionSchema>;
export type TextInputPayload = z.infer<typeof textInputPayloadSchema>;

export type ApprovalResume = { approved: boolean };
export type ChoiceResume = { pick: string };
export type TextInputResume = { answer: string };

export const toolApprovalPayloadSchema = z.object({
  toolName: z.string().min(1),
  toolDescription: z.string(),
  args: z.record(z.string(), z.unknown()),
  previewText: z.string(),
});

export type ToolApprovalPayload = z.infer<typeof toolApprovalPayloadSchema>;
